import React from "react";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

// Components
import Magnetic from "../../Common/Magnetic/Magnetic";

// SCSS
import "./ErrorWindow.scss";

const ErrorWindow = ({ setHoveredElement, onClose }) => {
  return (
    // Window
    <div className="ErrorWindow">
      {/* Section .Error */}
      <section className="Error">
        <div className="Error__Wrapper">
          <div className="Error__Warning">
            <span className="Error__Warning-Icon">
              <ExclamationTriangleFill />
            </span>

            <h3 className="Error__Warning-Title">404 Error</h3>
          </div>

          <p className="Error__Desc">
            null. undefined. nothing. this page doesn't exist.
          </p>

          <Magnetic
            setHoveredElement={setHoveredElement}
            as="button"
            type="button"
            className="Error__Button"
            onClick={onClose}
          >
            Ignore
          </Magnetic>
        </div>
      </section>
    </div>
  );
};

export default ErrorWindow;
